module.exports = __webpack_public_path__ + "static/img/be-trustworthy1.317b247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/be-trustworthy1.png
// module id = OgkC
// module chunks = 0